// @flow
import { isEmpty } from 'lodash';
import FreeWheelAd from 'Common/lib/player/FreeWheelAd';
import parser, { j2xParser as J2x } from 'fast-xml-parser';
import type { Cast } from 'Common/cast/types';

declare var cast: Cast;

export const addVmapToMedia = async (
  media: cast.framework.messages.MediaInformation,
  ad: FreeWheelAd,
) => {
  const response = await fetch(ad.url);
  const adsResponse = await response.text();

  // Do not try to optimize this
  const options = {
    attributeNamePrefix: '',
    attrNodeName: 'attr',
    textNodeName: '#text',
    ignoreAttributes: false,
    ignoreNameSpace: false,
    allowBooleanAttributes: true,
    parseNodeValue: false,
    parseAttributeValue: false,
    trimValues: false,
    cdataTagName: '__cdata',
    cdataPositionChar: '\\c',
    parseTrueNumberOnly: true,
    arrayMode: false,
    attrValueProcessor: a => a,
    tagValueProcessor: a => a,
    stopNodes: [
      'TrackingEvents',
      'VideoClicks',
      'Error',
      'Impression',
      'vmap:TrackingEvents',
      'MediaFiles',
    ],
  };

  const json = parser.parse(adsResponse, options);

  // Can be an object or an array of objects
  const adBreaks = json['vmap:VMAP'] ? json['vmap:VMAP']['vmap:AdBreak'] : undefined;
  if (!adBreaks) return;

  // Safely gets Ads from an AdBreak
  const getAdsInAdBreak = adBreak =>
    adBreak['vmap:AdSource'] ? adBreak['vmap:AdSource']['vmap:VASTAdData']?.VAST?.Ad : undefined;

  // Removes empty Ads from an AdBreak
  const filterAdsInAdBreak = adBreak => {
    const Ad = getAdsInAdBreak(adBreak);
    if (Array.isArray(Ad)) {
      adBreak['vmap:AdSource']['vmap:VASTAdData'].VAST.Ad = Ad.filter(ad =>
        Object.keys(ad).includes('InLine'),
      );
    }
  };

  // Checks if an AdBreak is good, ie it contains a MediaFiles node
  const isAdBreakGood = (adBreak): boolean => {
    const Ad = getAdsInAdBreak(adBreak);
    if (isEmpty(Ad)) return false;
    return Array.isArray(Ad)
      ? Ad.reduce((acc, ad) => {
          if (acc) return acc;
          return !isEmpty(ad.InLine?.Creatives?.Creative?.Linear?.MediaFiles);
        })
      : !isEmpty(Ad?.InLine?.Creatives?.Creative?.Linear?.MediaFiles);
  };

  if (Array.isArray(adBreaks)) {
    adBreaks.forEach(filterAdsInAdBreak);
    json['vmap:VMAP']['vmap:AdBreak'] = adBreaks.filter(isAdBreakGood);
  } else {
    const adBreak = adBreaks;
    filterAdsInAdBreak(adBreak);
    json['vmap:VMAP']['vmap:AdBreak'] = isAdBreakGood(adBreak) ? adBreak : undefined;
  }

  const j2x = new J2x(options);
  const xml = j2x.parse(json);

  media.vmapAdsRequest = {
    adsResponse: xml,
  };
};
